/**
 * Removes the static cold-start boot loader injected in `app.html`. Fades it
 * out (respecting the CSS transition) and removes it, with a fallback removal
 * in case `transitionend` never fires.
 *
 * Idempotent: safe to call when the loader is already gone.
 */
export function removeBootLoader(): void {
  const bootLoader =
    typeof document !== 'undefined' ? document.getElementById('app-boot-loader') : null;
  if (!bootLoader) return;

  bootLoader.classList.add('app-boot-loader--hidden');
  bootLoader.addEventListener('transitionend', () => bootLoader.remove(), { once: true });
  // Fallback removal in case the transitionend event never fires.
  setTimeout(() => bootLoader.remove(), 400);
}
